import React, {useLayoutEffect} from 'react'
import {Outlet, useNavigate} from "react-router-dom";
import {connect} from "react-redux";
import {autoLogin} from "./store/auth/login/actions";

const Root = ({autoLogin}) => {
  const history = useNavigate()
  useLayoutEffect(() => {
    autoLogin(history)
    // eslint-disable-next-line react-hooks/exhaustive-deps -- auto-login once per app load. react-router 6.8's useNavigate returns a new function on every pathname change, so depending on `history` would re-dispatch AUTO_LOGIN (and re-hit /me) on every navigation.
  }, [])
    return (
        <>
            <Outlet/>
        </>
    )
}
const mapStateToProps = (state) => {
  return {}
};

export default connect(mapStateToProps, {autoLogin})(Root)
